module.exports = __webpack_public_path__ + "static/media/gris.6c7addae.mp3";